import { createFileRoute } from "@tanstack/react-router";

import { ScoreTakingDebugPreview } from "~/features/game/components/ScoreTakingDebugView/ScoreTakingDebugPreview.tsx";
import { parseDebugSearch } from "~/features/game/components/ScoreTakingDebugView/scoreTakingDebugSearch.ts";
import { resolveDebugSelection } from "~/features/game/components/ScoreTakingDebugView/scoreTakingDebugUtils.ts";

const ScoreTakingDebugPreviewPage = () => <ScoreTakingDebugPreview {...resolveDebugSelection(Route.useSearch())} />;

export const Route = createFileRoute("/_auth/dev/score-taking/preview")({
    validateSearch: parseDebugSearch,
    component: ScoreTakingDebugPreviewPage,
});
